enum features  {'profile', 'sideMenu', 'autoAccess','dashboard', 'managePlan','rules','booking','dm','taskManagment','websiteBuilder','controlCenter','freemiumOnboarding','freemiumReferral'}

const disabledFeatures: Record<keyof typeof features, boolean> = {
  sideMenu: import.meta.env.VITE_FEATURE_MENU === 'false',
  profile: import.meta.env.VITE_FEATURE_PROFILE === 'false',
  autoAccess: import.meta.env.VITE_FEATURE_AUTO_ACCESS === 'false',
  managePlan: import.meta.env.VITE_MANAGE_PLAN === 'false',
  dashboard: import.meta.env.VITE_FEATURE_DASHBOARD === 'false',
  rules: import.meta.env.VITE_AVAILABLILITY_RULES === 'false', 
  booking:import.meta.env.VITE_BOOKING === 'false', 
  dm:import.meta.env.VITE_DM === 'false',
  taskManagment:import.meta.env.VITE_TASK === 'false',
  websiteBuilder:import.meta.env.VITE_WBSITE_BUILDER === 'false',
  controlCenter:import.meta.env.VITE_CONTROL_CENTER === 'false',
  // Independent of VITE_WBSITE_BUILDER: /start is public acquisition surface
  freemiumOnboarding:import.meta.env.VITE_FREEMIUM_ONBOARDING === 'false',
  // Opt-IN (hidden by default): the S9 referral invite is pulled for now and
  // returns later — show it only when VITE_FREEMIUM_REFERRAL === 'true'.
  freemiumReferral:import.meta.env.VITE_FREEMIUM_REFERRAL !== 'true'
};

export { disabledFeatures };
